import React, { memo } from 'react'
import Card from '@/primitives/Card'
import Slot from '@/primitives/Slot'
import FlexV2 from '@/primitives/FlexV2'
import Icon from '@/primitives/Icon'
import Text from '@/primitives/Text'
import Collapse from '@/primitives/Collapse'
import './VirtualAssistant.scss'

import { ExperimentalBadge } from './components/shared'
import ExecutiveSummary from './components/ExecutiveSummary'
import AudioOverview from './components/AudioOverview'
import AIChat from './components/AIChat'
import Strings from '../../Strings'

const VirtualAssistant = memo(({ isSmallScreen }) => {
  const titleSize = isSmallScreen ? 300 : 400

  const header = (
    <>
      <FlexV2 alignCrossAxis='center' alignMainAxis='space-between'>
        <FlexV2 alignCrossAxis='center' axisGap={200}>
          <Icon
            name='smart_toy'
            size={titleSize}
            variant='primary'
            tone={600}
          />
          <Text size={titleSize} fontWeight={600}>
            {Strings().trialAssistant}
          </Text>
        </FlexV2>
      </FlexV2>
      <ExperimentalBadge />
    </>
  )

  const assistantPanels = (
    <FlexV2 direction='column' axisGap={300}>
      <ExecutiveSummary />
      <AudioOverview />
      <AIChat />
    </FlexV2>
  )

  if (isSmallScreen) {
    return (
      <Card>
        <Slot name='body'>
          <Collapse defaultOpen={false}>
            <Slot name='trigger'>{header}</Slot>
            <Slot name='content'>{assistantPanels}</Slot>
          </Collapse>
        </Slot>
      </Card>
    )
  }

  return (
    <Card>
      <Slot name='header'>{header}</Slot>
      <Slot name='body'>{assistantPanels}</Slot>
    </Card>
  )
})

export default VirtualAssistant
